import React from 'react'
import img from "../../assets/images/img1.png"
const HeaderPage = () => {
  return (
    <div>
      <section className="bg-white dark:bg-gray-900 m-1 mt-20">
        <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
          <div className="mr-auto place-self-center lg:col-span-7">
            <h1 className="max-w-2xl mb-4 text-4xl font-bold font-mfont tracking-tight leading-none md:text-4xl
             xl:text-6xl dark:text-white">
              Throbbing Innovation and Solutions</h1>
            <p className="max-w-2xl mb-6 font-semibold font-mfont text-2xl text-black lg:mb-8 md:text-lg lg:text-xl 
            dark:text-gray-400">Building Digital Products and Brands from ERP to CRM, E-Commerce and CMS.</p>

            <a href="mailto:teammakingminds@gmail.com"
              target="_blank"
              rel="noreferrer" className="inline-flex text-center uppercase items-center
               justify-center px-5 py-3 mr-3 text-base 
            font-medium  text-white rounded-sm bg-mcolor hover:bg-mcolor hover:opacity-75  
            focus:ring-gray-300 active:opacity-[0.85]
            focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
              Get Started for Free
              <svg className="w-5 h-5 ml-2 -mr-1" fill="currentColor"
                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </a>
          </div>
          <div className=" lg:mt-0 lg:col-span-5 lg:flex">
            <img src={img} alt="mockup" className='' />

          </div>
        </div>
      </section>
      {/* <section className="bg-white dark:bg-gray-900 m-1 mt-20">
        <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">

          <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none font-mfont
           text-mblack md:text-5xl lg:text-6xl dark:text-white"> Throbbing Innovation and Solutions</h1>
          <p className="mb-8 text-2xl font-semibold text-mblack lg:text-xl sm:px-16 xl:px-48
           dark:text-gray-400">Building Digital Products and Brands from ERP to CRM, E-Commerce and CMS.</p>
          <div className="flex flex-col mb-8 lg:mb-16 space-y-4 sm:flex-row sm:justify-center
           sm:space-y-0 sm:space-x-4">
            <a href="mailto:teammakingminds@gmail.com"
              target="_blank"
              rel="noreferrer" className="inline-flex text-center uppercase items-center
               justify-center px-5 py-3 mr-3 text-base 
            font-medium  text-white rounded-sm bg-mcolor hover:bg-mcolor
            focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
              Get Started for Free
              <svg className="w-5 h-5 ml-2 -mr-1" fill="currentColor"
                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </a>

          </div>

        </div>
      </section> */}
    </div>
  )
}

export default HeaderPage